

export const phoneRegex = /^\(\d{2}\) \d{4,5}-\d{4}$/;